import { prop } from "ramda";
import { createSelector } from "reselect";
import { STATE_IDENTIFIER } from "./constants";

const {
  QUESTIONS,
  QUESTIONS_LOADER,
  USER,
  OTP,
  REQUEST_STATE_QUESTION,
  REQUEST_STATE_OTP,
  TOKEN_TMP,
  TOKEN_TYPE,
  PASSW_POLICY,
  RETRYS,
  REQUEST_STATE_PASSWORD,
  FIRST_ACCESS,
  OLD_PASSWORD,
} = STATE_IDENTIFIER;

const loginSelector = (state: any) => state.login;

export const firstAccessSelector: any = createSelector(
  loginSelector,
  prop(FIRST_ACCESS)
);

export const selectOldPwdSelector: any = createSelector(
  loginSelector,
  prop(OLD_PASSWORD)
);

export const loginQuestionsSelector: any = createSelector(
  loginSelector,
  prop(QUESTIONS)
);
export const loginQuestionsLoaderSelector: any = createSelector(
  loginSelector,
  prop(QUESTIONS_LOADER)
);

export const userLoginSelector: any = createSelector(loginSelector, prop(USER));

export const otpLoginSelector: any = createSelector(loginSelector, prop(OTP));

export const responseQuestionSelector: any = createSelector(
  loginSelector,
  prop(REQUEST_STATE_QUESTION)
);

export const responseOtpSelector: any = createSelector(
  loginSelector,
  prop(REQUEST_STATE_OTP)
);

export const tokenSelector: any = createSelector(
  loginSelector,
  prop(TOKEN_TMP)
);

export const tokenTypeSelector: any = createSelector(
  loginSelector,
  prop(TOKEN_TYPE)
);

export const passwordPolicySelector: any = createSelector(
  loginSelector,
  prop(PASSW_POLICY)
);

export const selectRetrysCount: any = createSelector(
  loginSelector,
  prop(RETRYS)
);

export const selectPasswordResponse: any = createSelector(
  loginSelector,
  prop(REQUEST_STATE_PASSWORD)
);
